import Vue from 'vue/dist/vue.esm'
import Rails from '@rails/ujs'
import { reviewForExistingFcmToken } from '../firebase'

document.addEventListener('DOMContentLoaded', () => {
  const $el = document.getElementById('contact_message')

  if ($el != null) {
    const ua = window.navigator.userAgent
    const orderId = $el.dataset.order

    new Vue({
      el: $el,
      data: {
        addOrder: 'false',
        happy: 'true',
        input: '',
        notificationActive: sessionStorage.getItem('_w_daban'),
        messageType: orderId !== '' ? 'petition' : 'congratulations',
        orderId: orderId,
        score: 4
      },
      mounted () {
        reviewForExistingFcmToken()
        this.getIp()
      },
      methods: {
        activateNotifications () {
          sessionStorage.removeItem('_w_daban')
          reviewForExistingFcmToken()
        },
        getDeviceType () {
          if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return 'tablet'
          }

          if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return 'mobile'
          }
          return 'desktop'
        },
        getBrowser () {
          let tem = ''
          let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
          if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || []
            return 'IE ' + (tem[1] || '')
          }
          if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge?)\/(\d+)/)
            if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ')
          }
          M = M[2] ? [M[1], M[2]] : [window.navigator.appName, window.navigator.appVersion, '-?']
          if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
          return M.join(' ')
        },
        getIp () {
          Rails.ajax({
            url: 'https://api.ipify.org?format=json',
            type: 'GET',
            crossDomain: true,
            dataType: 'json',
            success: (data) => {
              const ip = document.getElementById('ip')
              ip.value = data.ip
            },
            error: (error) => {
              console.error('Error: ', error)
            }
          })
        },
        getVersion () {
          let OSName = 'Unknown'
          if (window.navigator.userAgent.indexOf('Windows NT 11.0') !== -1) OSName = 'Windows 11'
          if (window.navigator.userAgent.indexOf('Windows NT 10.0') !== -1) OSName = 'Windows 10'
          if (window.navigator.userAgent.indexOf('Windows NT 6.2') !== -1) OSName = 'Windows 8'
          if (window.navigator.userAgent.indexOf('Windows NT 6.1') !== -1) OSName = 'Windows 7'
          if (window.navigator.userAgent.indexOf('Windows NT 6.0') !== -1) OSName = 'Windows Vista'
          if (window.navigator.userAgent.indexOf('Windows NT 5.1') !== -1) OSName = 'Windows XP'
          if (window.navigator.userAgent.indexOf('Windows NT 5.0') !== -1) OSName = 'Windows 2000'
          if (window.navigator.userAgent.indexOf('Mac') !== -1) OSName = 'Mac/iOS'
          if (window.navigator.userAgent.indexOf('X11') !== -1) OSName = 'UNIX'
          if (window.navigator.userAgent.indexOf('Linux') !== -1) OSName = 'Linux'
          return OSName
        },
        getSize () {
          return window.innerWidth + 'x' + window.innerHeight
        },
        otherOption (event) {
          const value = event.target.value
          const radio = document.getElementById('customRadio8')
          if (value) {
            radio.checked = true
            this.messageType = this.input
          } else {
            radio.checked = false
            this.messageType = 'congratulations'
            document.getElementById('customRadio1').checked = true
          }
        }
      }
    })
  }
})
